import state from './goPosState'
import mutations from './goPosMutations'
import actions from './goPosActions'
import getters from './goPosGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
